import {
  DATE_SELECTION_OPTIONS,
  type DateSelectionOption,
  type Period,
  type ProductTaxonomyType
} from '@carrefour-gcs/shared';

export type SelectedIntervalType = {
  from: Date;
  to: Date;
};

export function isCumulativeOptionGuard(value: string): value is DateSelectionOption {
  return DATE_SELECTION_OPTIONS.includes(value as DateSelectionOption);
}

export type DateIntervalType = { start?: Date; end?: Date };

export interface AvailablePeriodType {
  period: Period;
  unavailableMessage?: string;
}

type PeriodType<T> = {
  periods: Period[];
  unavailableMessage: T;
};

export type ReferentialPeriodType = {
  [keys in ProductTaxonomyType]: {
    availablePeriod: PeriodType<'availableOnCarrefour' | 'availableOnNielsen'>;
    unavailablePeriods?: PeriodType<string>;
  };
};

export const REFERENTIAL_PERIOD: ReferentialPeriodType = {
  carrefour: {
    availablePeriod: {
      periods: ['daily', 'weekly', 'monthly'],
      unavailableMessage: 'availableOnNielsen'
    }
  },
  nielsen: {
    availablePeriod: {
      periods: ['weekly', 'nielsen'],
      unavailableMessage: 'availableOnCarrefour'
    }
  }
};
